import { render, staticRenderFns } from "./tabDatalogger.vue?vue&type=template&id=0593d81c&scoped=true&"
import script from "./tabDatalogger.vue?vue&type=script&lang=js&"
export * from "./tabDatalogger.vue?vue&type=script&lang=js&"
import style0 from "./tabDatalogger.vue?vue&type=style&index=0&id=0593d81c&lang=less&scoped=true&"
import style1 from "./tabDatalogger.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0593d81c",
  null
  
)

export default component.exports